export const UNISWAP_TICK = 1.0001;
export const MIN_POSITION_LEVERAGE = 1;
